import { render } from "./EditGps.vue?vue&type=template&id=00f97779"
import script from "./EditGps.vue?vue&type=script&lang=js"
export * from "./EditGps.vue?vue&type=script&lang=js"
script.render = render

export default script